import Icon from '../../@shared/icon';
import { NavigationItemMenuModel } from '../models/navigationItem.model';
import { NavigationItemTray } from './navigationItemMenu';
import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { iconSize } from '../../../constants/icon.constants';
import { useMenuItemWithContext } from './menuContext';
import useAnimationEnd from '../../../hooks/useUnMountOnAnimationEnd';

const NavigationAccordionItem = (props: { model: NavigationItemMenuModel; closeMainNavigation }) => {
  const [isOpen, setOpen] = useMenuItemWithContext();
  const canShowDOM = useAnimationEnd(isOpen, 290);
  const handleClick = () => {
    setOpen(!isOpen);
  };
  const { model, closeMainNavigation } = props;
  const icon = isOpen ? 'arrow-chevron-up' : 'arrow-chevron-down';
  return (
    <li className="navigation__accordion-item">
      <button
        type="button"
        className={`navigation__accordion-item__trigger ${isOpen ? 'navigation__accordion-item__trigger--open' : ''}`}
        onClick={handleClick}
      >
        <RichText field={model.menuTitle} tag="div" className={`rich-text ${isOpen ? 'navigation__accordion-item__menu-title' : ''}`} />
        <Icon extraClassName="navigation__accordion-item__trigger__icon" iconName={icon} color="primary" size={iconSize.sm} />
      </button>

      <div className="navigation__accordion-item__tray">
        {canShowDOM && <NavigationItemTray model={model} closeMainNavigation={closeMainNavigation} isOpen={isOpen} />}
      </div>
    </li>
  );
};

export default NavigationAccordionItem;
